import type { RigState, StatusTile } from '../lib/types';

interface Props {
  currentActivity: string;
  tiles: StatusTile[];
  rigStates: RigState[];
  lastData: string;
}

export function StatusStrip({ currentActivity, tiles, rigStates, lastData }: Props) {
  return (
    <div className="statusstrip">
      <section className="status-group" aria-label="Current readings">
        <div className="readout readout--wide">
          <span className="readout-label">
            Current
            <br />
            Activity
          </span>
          <output className="readout-value readout-value--activity">{currentActivity}</output>
        </div>

        {tiles.map((tile) => (
          <div className="readout" key={tile.label}>
            <span className="readout-label">{tile.label}</span>
            <output className={`readout-value readout-value--${tile.tone}`}>{tile.value}</output>
            {tile.unit && <span className="readout-unit">{tile.unit}</span>}
          </div>
        ))}
      </section>

      <section className="status-group" aria-label="Rig state">
        {rigStates.map((state) => (
          <div className="rigstate" key={state.label}>
            <span className="rigstate-label">{state.label}</span>
            <span
              className={state.active ? 'rigstate-lamp is-on' : 'rigstate-lamp'}
              role="img"
              aria-label={`${state.label}: ${state.active ? 'active' : 'inactive'}`}
            />
          </div>
        ))}

        <div className="readout">
          <span className="readout-label">
            Last
            <br />
            Data
          </span>
          <output className="readout-value readout-value--amber">{lastData}</output>
        </div>
      </section>
    </div>
  );
}
